import React from "react";
import ReactDOM from "react-dom";
import StripeCheckout from "./stripe/Checkout";

const Checkout = (props) => {
  const { stripe, order, termsHref } = props;

  return (
    <StripeCheckout
      stripePublishableKey={stripe.publishableKey}
      clientSecret={stripe.clientSecret}
      draftOrderId={order.draftOrderId}
      cost={order.cost}
      costInPounds={order.costInPounds}
      orderName={order.orderName}
      termsHref={termsHref}
    />
  );
};

export default Checkout;

document.addEventListener("DOMContentLoaded", () => {
  const node = document.getElementById("checkout");
  if (!node) return;

  const rawData = node.dataset.reactCheckoutPropsValue;
  if (!rawData) return;

  const data = JSON.parse(rawData);

  ReactDOM.render(<Checkout order={data.order} stripe={data.stripe} termsHref={data.termsHref} />, node);
});
